import React, { useEffect, useState } from 'react';
import { UilMoon, UilSun } from '@iconscout/react-unicons';

const ThemeSwitcher = () => {
   const [theme, setTheme] = useState(() => {
      if (typeof window === 'undefined') return 'dark';
      const stored = localStorage.getItem('theme');
      if (stored) return stored;
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
   });

   useEffect(() => {
      const root = document.documentElement;
      if (theme === 'dark') root.classList.add('dark');
      else root.classList.remove('dark');
      localStorage.setItem('theme', theme);
   }, [theme]);

   return (
      <button
         onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
         aria-label="Toggle theme"
         className="group inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/30 bg-white/20 text-white backdrop-blur-md transition hover:bg-white/30 hover:scale-105"
      >
         {theme === 'light' ? (
            <UilMoon className="h-5 w-5 transition-transform group-hover:-rotate-12" />
         ) : (
            <UilSun className="h-5 w-5 transition-transform group-hover:rotate-45" />
         )}
      </button>
   );
};

export default ThemeSwitcher;
